import Wasalt from '../../assets/projects-image/Wasalt.png';
import DarGlobal from '../../assets/projects-image/DarGlobal.png';
import CSCampus from '../../assets/projects-image/CS_Campus.png';
import RofialBeauty from '../../assets/projects-image/Rofial_Beauty.png';
import SoulfullEats from '../../assets/projects-image/Soulfull-eats.png';
import WildOakBoutique from '../../assets/projects-image/Wild-Oak-Boutique.png';
import AirMaster from '../../assets/projects-image/Air-master.png';
import Ros3Clothing from '../../assets/projects-image/Ros3-Clothings.png';
import Ninjamo from '../../assets/projects-image/Ninjamo.png';
import TheDailyOutfit from '../../assets/projects-image/The-Daily-Outfits.png';
import MallKoStore from '../../assets/projects-image/Mall-ko-store.png';
import KidFromWest from '../../assets/projects-image/Kid-from-west.png';
import MotherLoving from '../../assets/projects-image/Mother-loving.png';

const projectsData =  {
    "Projects": [
        {
          "image": Wasalt,
          "alt": "Wasalt",
          "title": "Wasalt Website Revamp",
          "link": "https://wasalt.com"
        },
        {
          "image": DarGlobal,
          "alt": "DarGlobal",
          "title": "DarGlobal Website Revamp",
          "link": "https://darglobal.co.uk/"
        },
        {
            "image": CSCampus,
            "alt": "CSCampus",
            "title": "CS Campus management",
            "link": "https://cscampusblazer.corporateserve.com/facultyDashboard"
        },
        {
            "image": RofialBeauty,
            "alt": "RofialBeauty",
            "title": "Rofial Beauty",
            "link": "https://rofialbeauty.com/"
        },
        {
            "image": SoulfullEats,
            "alt": "SoulfullEats",
            "title": "Soulfull Eats",
            "link": "https://www.soulfulleatsjax.com/"
        },
        {
            "image": WildOakBoutique,
            "alt": "WildOakBoutique",
            "title": "Wild Oak Boutique",
            "link": "https://www.wildoakboutique.com/"
        },
        {
            "image": AirMaster,
            "alt": "AirMaster",
            "title": "Air Master",
            "link": "https://airmasterph.com/"
        },
        {
            "image": Ros3Clothing,
            "alt": "Ros3Clothing",
            "title": "Ros Clothing",
            "link": "https://ros3clothing.com/"
        },
        {
            "image": Ninjamo,
            "alt": "Ninjamo",
            "title": "Ninjamo",
            "link": "https://www.ninjamo.com/"
        },
        {
            "image": TheDailyOutfit,
            "alt": "TheDailyOutfit",
            "title": "The Daily Outfits",
            "link": "https://www.thedailyoutfits.com/"
        },
        {
            "image": MallKoStore,
            "alt": "MallKoStore",
            "title": "Mall Ko Store",
            "link": "https://mallko.store/"
        },
        {
            "image": KidFromWest,
            "alt": "KidFromWest",
            "title": "Kid From the West",
            "link": "https://kid-west.com/"
        },
        {
            "image": MotherLoving,
            "alt": "MotherLoving",
            "title": "Mother Loving Care",
            "link": "https://motherlovingcare.com/"
        }
    ]
}

export default projectsData;